export const API_BASE_URI = process.env.REACT_APP_API_BASE_URI;
export const API_FETCH_CONTENT = process.env.REACT_APP_API_FETCH_CONTENT ? process.env.REACT_APP_API_FETCH_CONTENT : '';
export const API_VIDEO_CONTENT = process.env.REACT_APP_API_VIDEO_CONTENT;
export const IS_SENTRY_REQUIRED = process.env.REACT_APP_IS_SENTRY_REQUIRED;
export const SENTRY_RELEASE_VERSION = process.env.REACT_APP_SENTRY_RELEASE_VERSION;
export const ENVIRONMENT = process.env.REACT_APP_NODE_ENV === 'production' ? 'production' : 'dev';
export const RELEASE = process.env.REACT_APP_VERSION;
export const WHITE_LABEL_ENABLED = process.env.REACT_APP_WHITE_LABEL_ENABLED;
export const IS_LOCAL = process.env.REACT_APP_IS_LOCAL === '1' ? 1 : 0;
